import React from 'react';
import loader from "../../assets/loaders/food.gif";

export interface LoaderProps {
    isLoading: boolean;
}

const Loader = ( props: LoaderProps) => {

    if (props.isLoading)
        return <div className="loaderContainer">
            <img className="loader" src={loader} alt="Loading..." />
        </div>

    return null;
}
 
export default Loader;